import { normalize } from 'normalizr';

import { request, getDate, dumpVaRatesGraphByCurrency } from 'utils';

import { ratesTimeGraph as timeSchema, ratesGraph as schema } from 'schemas';

import {
  // FETCH_RATES_GRAPH_REQUEST,
  FETCH_RATES_GRAPH_SUCCESS,
  FETCH_RATES_GRAPH_FAILURE,
} from 'actionTypes';

import {
  makeGetRatesGraphIsFetching,
  makeGetRatesGraphIsInitialized,
} from 'selectors';

const GROUP = {
  day: '',
  week: '&period=week',
  month: '&period=month&group=day',
  quarter: '&period=3month&group=week',
};

const getRatesGraphIsFetching = makeGetRatesGraphIsFetching();
const getRatesGraphIsInitialized = makeGetRatesGraphIsInitialized();

const shouldFetchRatesGraph = (state, params) => {
  const isFetching = getRatesGraphIsFetching(state, params);
  const isInitialized = getRatesGraphIsInitialized(state, params);

  return !(isFetching || isInitialized);
};

const getParams = params => {
  const { currentDate, period } = params;

  const { dateFrom, dateTo } = getDate(currentDate, period);

  if (currentDate) {
    return {
      period,
      dateFrom,
      dateTo,
    };
  }

  return params;
};

export const fetchRatesGraph = params => async (dispatch, getState) => {
  const currentState = getState();

  const { dateFrom, dateTo, period = 'day' } = getParams(params);
  const { currentDate, requestType, sourceCurrency, city = null } = params;

  const isDateFromTo =
    !!params?.date?.custom?.from || !!params?.date?.custom?.to;

  const currenciesKey = `${params.sourceCurrency}-${params.targetCurrency}`;

  if (
    !currentDate && // TODO перенести перевірку дати і періоду в селектори
    !isDateFromTo &&
    !shouldFetchRatesGraph(currentState, params)
  ) {
    return true;
  }

  try {
    const requestUrl =
      requestType === 'exchanger'
        ? `${process.env.APP_VA_RATES_API}?${GROUP[period]}`
        : `${
            process.env.APP_CURRENCIES_API_URL
          }/rates/${requestType}/${sourceCurrency.toLowerCase()}/${
            requestType === 'interbank' ? 'last' : 'avg'
          }`;

    const requestParams =
      requestType === 'exchanger'
        ? {
            currency: sourceCurrency.toLowerCase(),
            city,
          }
        : {
            period,
            from: params.date?.custom?.from || dateFrom,
            to: params.date?.custom?.to || dateTo,
          };

    const response = await request({
      url: `${requestUrl}`,
      params: requestParams,
    });

    let data = null;

    if (requestType === 'interbank') {
      data = response.data[params.sourceCurrency].reverse();
    } else if (requestType === 'exchanger') {
      data = dumpVaRatesGraphByCurrency(
        response.items[params.sourceCurrency.toLowerCase()]
      );
    } else {
      data = response.data.reverse();
    }

    const {
      entities: { ratesGraph: entities = {} } = {},
      result: ids = [],
    } = normalize(data, period === 'day' ? timeSchema : schema);

    return dispatch({
      type: FETCH_RATES_GRAPH_SUCCESS,
      payload: {
        currenciesKey,
        periodKey: period || 'day',
        entities,
        ids,
        type: requestType,
      },
    });
  } catch (error) {
    return dispatch({
      type: FETCH_RATES_GRAPH_FAILURE,
      payload: { currenciesKey, periodKey: period, type: requestType },
    });
  }
};

export default fetchRatesGraph;
